import { useState } from 'react';
import fetchGuestSession from '../tools/UserState/fetchGuestSession';

export const hasPrimaryOrSecondarySelected = (verifiedCriteria) => {
  if (!verifiedCriteria) return false;
  const { primarySize, secondarySize } = verifiedCriteria;
  return !!primarySize || !!secondarySize;
};

const useSubmitAddToBag = ({
  onMutationSubmit,
  collectionData,
  isGenericUser,
  store,
  isQuickviewEdit,
  orderItemId,
  handleFormError,
  setActiveButtonLabel,
  tmntData,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmitForm = async (quantity) => {
    const isSizeSelected = hasPrimaryOrSecondarySelected(collectionData.verifiedCriteria);
    const shortSku = collectionData.qualifiedSku;

    if (shortSku && isSizeSelected && !isSubmitting) {
      setIsSubmitting(true);
      setActiveButtonLabel('addToBagProcessing');

      try {
        if (isGenericUser()) {
          await fetchGuestSession(store);
        }

        const mutationVariables = isQuickviewEdit
          ? { shortSku, orderItemId }
          : { shortSku, quantity: parseInt(quantity, 10) };

        await onMutationSubmit({
          variables: { ...mutationVariables },
        });
      } catch (err) {
        handleFormError(tmntData?.guestSessionInitError);
      } finally {
        setIsSubmitting(false);
      }
    } else {
      handleFormError();
    }
  };

  return { isSubmitting, handleSubmitForm };
};

export default useSubmitAddToBag;
